export default __webpack_public_path__ + "media/zurb/img/ecommerce/esv-60a125b3dd5e7236ce5d0247d33f8bed.png";